var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { AfyCardCategoryPick, CardCategoryPickDot, } from "@affinitysystemsgroup/assurehub-ui";
import { IconBuilding, IconFolder, IconTag } from "@tabler/icons-react";
import { CategoryPickerCard, CategoryPickerLabel, CategoryPickerNote, CategoryPickerRow, } from "../style/categoryPicker.style";
var CATEGORY_ICONS = {
    Project: _jsx(IconFolder, { size: 16 }),
    ProjectType: _jsx(IconTag, { size: 16 }),
    Client: _jsx(IconBuilding, { size: 16 }),
};
export var CategoryPickerView = function (props) {
    var _a;
    var selectedOption = props.options.find(function (option) { return option.selected; });
    return (_jsxs(CategoryPickerCard, { children: [_jsx(CategoryPickerLabel, { children: props.groupLabel }), _jsx(CategoryPickerRow, { children: props.options.map(function (option) {
                    var _a;
                    return (_jsx(AfyCardCategoryPick, { icon: (_a = CATEGORY_ICONS[option.entityName]) !== null && _a !== void 0 ? _a : _jsx(IconFolder, { size: 16 }), name: option.label, subtitle: option.subtitle, dot: option.dot === "warning"
                            ? CardCategoryPickDot.Warn
                            : option.dot === "info"
                                ? CardCategoryPickDot.Info
                                : undefined, selected: option.selected, onClick: function () { return props.onSelect(option.entityName); } }, option.entityName));
                }) }), (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.note) && (_jsx(CategoryPickerNote, __assign({ "$tone": (_a = selectedOption.noteType) !== null && _a !== void 0 ? _a : "info" }, { children: selectedOption.note })))] }));
};
export default CategoryPickerView;
